import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export const MAX_POSTS_SELECTED = 3;

export type Tproposal = {
  _id: string;
  title: string;
  location: string;
  workModel: string;
  description: string;
  workTasks: string[];
  workRequirements: string[];
  workConditions: string[];
  finalMessage: string;
  createdAt: string;
  updatedAt: string;
  isPinned?: boolean;
  __v: number;
};

const initialState = {
  proposalsList: Array<Tproposal>(),
  selectedProposals: [] as string[],
};

const proposalsSlice = createSlice({
  name: "proposals",
  initialState,
  reducers: {
    setProposals(state, action) {
      const { data } = action.payload;
      state.proposalsList = data;
    },
    deleteProposal(state, action) {
      const { id } = action.payload;
      // const index = state.proposalsList.findIndex(
      //   (proposal) => proposal._id === id
      // );
      // state.proposalsList.splice(index, 1);

      state.proposalsList = state.proposalsList.filter(
        (proposal) => proposal._id !== id
      );
      state.selectedProposals = state.selectedProposals.filter(
        (selectedId) => selectedId !== id
      );
    },
    toggleProposal: (state, action: PayloadAction<string>) => {
      const id = action.payload;

      if (state.selectedProposals.includes(id)) {
        // Si el ID ya está seleccionado, lo elimina
        state.selectedProposals = state.selectedProposals.filter(
          (selectedId) => selectedId !== id
        );
      } else {
        state.selectedProposals.push(id);
      }
    },
    setAllProposals: (state, action: PayloadAction<string[]>) => {
      state.selectedProposals = action.payload;
    },
  },
});

export const { setProposals, deleteProposal, toggleProposal, setAllProposals } =
  proposalsSlice.actions;
export default proposalsSlice.reducer;
